import { render } from "./SocialLink.vue?vue&type=template&id=62ba43a7&scoped=true"
import script from "./SocialLink.vue?vue&type=script&lang=ts"
export * from "./SocialLink.vue?vue&type=script&lang=ts"

import "./SocialLink.vue?vue&type=style&index=0&id=62ba43a7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62ba43a7"

export default script